<template>
	<div class="main-container" @click="tabsMoreClose">
		<div class="main-container-body">
			<div class="body-left" :class="{ 'body-left-colla': collaMenuData }">
				<div class="menu-container">
					<div class="left" v-if="!collaMenuData"> </div>
					<div class="right" :class="{ 'right-colla': collaMenuData }" @click="collaMenu"></div>
				</div>
				<el-menu ref="elMenu" class="body-left-menu" background-color="#282828" text-color="#FFFFFF"
					active-text-color="#488DD6" :unique-opened="true" :default-active="activeIndex"
					:collapse="collaMenuData" @select="menuSelect">

					<navi-menu-item-container v-for="(item, index) in naviData"
						:key="`navi-menu-item-container${index}`" :naviData="item" :collapse="collaMenuData">
					</navi-menu-item-container>
				</el-menu>
			</div>
			<div class="body-right">

				<div class="body-right-header">
					<!-- tabs面包屑 -->
					<el-tabs class="body-right-header-tabs" type="card" v-model="selectedTab" @tab-click="tab"
						@tab-remove="tabClose">
						<el-tab-pane v-for="(item, index) in tabs" :key="`tab${item.path}${index}`"
							:closable="item.text !== '首页'" :name="item.path">
							<template #label>
								<span><i :class="item.icon"></i> {{ item.text }}</span>
							</template>
						</el-tab-pane>
					</el-tabs>
					<!-- 小×按钮 -->
					<div class="tabs-more" @click.stop="tabsMoreClick">
						<div class="icon">
							<div class="icon-bg"></div>
							<div class="icon-user-name">
								<span>{{ userName || "测试" }}</span>
								<i class="el-icon-arrow-down"></i>
							</div>
							<!-- <i class="el-icon-user-solid icon-user"></i> -->
						</div>
						<div class="shift" :class="{ 'shift-show': showTabsMoreShift }">
							<div class="shift-item" @click="closeCurrent">关闭</div>
							<div class="shift-item" @click="closeOther">关闭其他</div>
							<div class="shift-item" @click="closeAll">关闭所有</div>
							<div class="shift-item" @click="updatePasswordzxc">修改密码</div>
							<div class="shift-item" @click="exitFn">退出登录</div>
						</div>
					</div>
				</div>
				<div class="body-right-body homePage" v-if="memberPageData">
					<router-view v-slot="{ Component }">
						<transition name="el-zoom-in-center">
							<keep-alive :include="serviceSN">
								<component :is="Component"></component>
							</keep-alive>
						</transition>
					</router-view>
				</div>
				<div class="body-right-body" v-if="!memberPageData">
					<router-view v-slot="{ Component }">
						<transition name="el-zoom-in-center">
							<component :is="Component"></component>
						</transition>
					</router-view>
				</div>
			</div>
		</div>
		<pop-dialog v-if="showPop" ref="updatePassword" :showCancelButton="false" detailShowType="data"
			:meta="updatePasswordMeta" v-model:formDataWatch="formDataWatch" @dialogClose="updatePasswordClose"
			@confirmClick="updatePasswordComfirm">
		</pop-dialog>
		<div class="infoPop" :class="{'infoPopTransition': chatBox }">
			<div
				style="font-size: 28px;"
			>老板来人了。。。</div>{{ injectData }}
		</div>
	</div>
</template>

<script>

import mainButton from "@/components/mainButton.vue"
import naviMenuItemContainer from "@/components/naviMenuItemContainer.vue"
import {
	exit,
	updatePassword
} from "@/api/index.js"
import popDialog from "@/components/popDialog.vue"
import {
	errMsg,
	successMsg
} from "@/notify/index.js"
import AES from "@/util/Cryptography.js";
import { defineComponent, reactive, toRefs, onMounted, nextTick, computed, provide  } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"

const scrollStep = 100

export default defineComponent({
	name: "mainPage",
	components: {
		mainButton,
		popDialog,
		naviMenuItemContainer
	},
	setup() {
		let store = useStore()
		let router = useRouter()
		let validatePass = (rule, value, callback) => {
			console.log(value)
			if (value.length < 5) {
				return callback(new Error('密码长度必须大于5位'))
			} else {
				callback()
			}
		}

		let validatePassRepeat = (rule, value, callback) => {
			if (value.length < 5) {
				callback(new Error('密码长度必须大于5位'));
			} else if (value !== data.formDataWatch.newPassword) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback()
			}
		}
		const provideClick = (v)=>{
			console.log("provide---",v)
			methods.infoPop()
		}
		provide("chatInfo",provideClick)
		let data = reactive({
			injectData : null,
			activeIndex: null,
			elMenu: null,
			userName: "测试",
			memberPageData: true,
			dropDownList: [{
				text: "退出",
				id: "exit",
				className: "shift-icon-exit"
			}],
			showPop: false,
			updatePasswordMeta: [{
				headerLabel: "原始密码",
				dataIndex: "password",
				width: 120,
				editable: true,
				showInList: true,
				showInDetail: true,
				editType: 'password',
				rules: [{
					required: true,
					message: '请输入原始密码'
				}],
				renderToHtml: true
			}, {
				headerLabel: "新密码",
				dataIndex: "newPassword",
				width: 120,
				editable: true,
				showInList: true,
				showInDetail: true,
				editType: 'password',
				rules: [{
					required: true,
					message: '请输入新密码'
				}, {
					validator: validatePass,
					trigger: 'blur'
				}],
				renderToHtml: true
			}, {
				headerLabel: "确认密码",
				dataIndex: "repeatPassword",
				width: 120,
				editable: true,
				showInList: true,
				showInDetail: true,
				editType: 'password',
				rules: [{
					required: true,
					message: '请输入确认密码'
				}, {
					validator: validatePassRepeat,
					trigger: 'blur'
				}],
				renderToHtml: true
			}],
			formDataWatch: null,
			isExit: false,
			collaMenuData: false,
			showTabsMoreShift: false,
			updatePassword: null,
			tabsContainer: null,
			tabsContent: null,
			chatBox: false,
		})

		let methods = {
			dropDownListClick({
				item
			}) {
				if (item.id == "exit") {

					methods.exitFn()
				}
			},
			async exitFn() {
				data.isExit = true
				await exit()
				store.dispatch("set_clearLogin")
				router.push({
					path: "/login"
				})
			},
			userManage() {
				let path = "/home/userManagement"
				store.dispatch("set_currentChildRouterPath", path)
				router.push({
					path
				})
			},
			async memoryUserFn(e) {
				if (data.isExit) {
					window.localStorage.removeItem("login")
				} else {
					await methods.exit()
					let userName = store.getters.getUserName
					let password = store.getters.getPassword

					let obj = {
						userName,
						password
					}
					window.localStorage.setItem("login", JSON.stringify(obj))
				}
				e.preventDefault()
			},
			updatePasswordzxc() {
				data.showPop = true

				nextTick(() => {
					data.updatePassword.showPopDialog(null, "修改密码")
				})
			},
			// updatePassword() {
			// 	data.showPop = true

			// 	nextTick(() => {
			// 		data.updatePassword.showPopDialog(null, "修改密码")
			// 	})
			// },
			tab(item) {
				console.log(item.paneName)
				store.dispatch("set_selectedTab", item.paneName)
				let path = item.paneName
				console.log(item, 'iteomm')
				let tabs = computeds.tabs
				// debugger
				let t = tabs.value.find(i => i.path == path).text
				let obj = {
					text: t,
					path,
					icon: "el-icon-s-management"
				}
				// 设置左侧菜单的active项
				data.activeIndex = JSON.stringify(obj)
				// debugger
				// // data.elMenu.open(JSON.stringify(obj))
				// data.elMenu.open(obj)

				router.push({
					path
				})
			},
			tabMove(target) {
				let tabsContainer = data.tabsContainer
				let tabsContent = data.tabsContent

				let scrollLeft = tabsContent.scrollLeft
				let scrollTo = 0

				if (target === "right") {
					scrollTo = scrollLeft + scrollStep
				}

				if (target === "left") {
					scrollTo = scrollLeft - scrollStep
				}

				tabsContainer.scrollTo({
					left: scrollTo,
					behavior: "smooth"
				});
			},
			naviItemClick(obj) {
				let objPath = `${obj.path}`
				let hasItem = computeds.tabs.value.find(f => f.path == objPath)
				if (!hasItem) {
					let itemObj = {
						...obj
					}
					itemObj.path = objPath
					itemObj.closable = true
					let tabsArray = store.getters.getTabs
					tabsArray.push(itemObj)
					// 将选择的菜单推入到tabs数组中然后显示。
					store.dispatch("set_tabs", tabsArray)
					store.dispatch("set_selectedTab", itemObj.path)
					sessionStorage.setItem("set_tabs", JSON.stringify(tabsArray));
				} else {
					console.log(objPath)
					store.dispatch("set_selectedTab", objPath)
				}

				let path = objPath
				console.log(path)
				router.push({
					path
				})
			},
			tabClose(name) {
				console.log(name)
				let index = computeds.tabs.value.findIndex(f => f.path == name)
				if (index == 0) {
					return
				}
				let tabArray = computeds.tabs.value
				tabArray.splice(index, 1)
				store.dispatch("update_tabs", tabArray)

				let currentChildPath = store.getters.getCurrentChildRouterPath

				if (name == currentChildPath) {
					let path = computeds.tabs.value[index - 1].path
					store.dispatch("set_currentChildRouterPath", path)
					router.push({
						path
					})
					store.dispatch("set_selectedTab", path)
					// 设置左侧菜单项
					let tabs = computeds.tabs
					let t = tabs.value.find(i => i.path == path)?.text
					// debugger
					let obj = {
						text: t,
						path,
						icon: "el-icon-s-management"
					}
					// 设置左侧菜单的active项
					data.activeIndex = JSON.stringify(obj)
					// debugger
				}
			},
			updatePasswordClose() {
				data.showPop = false
			},
			updatePasswordComfirm({
				slotData
			}) {
				// {
				// 	"Id":3,
				// 	"oldPwd":"123456", 
				// 	"pwd":"1234567",
				// 	"Newpwd":"123456"
				// }
				// { 
				// 	id: null, 
				// 	password: "123456",
				// 	newPassword: "123123", 
				//	repeatPassword: "123123"
				// }


				let oldPassword = AES.getAES(slotData.password)
				let newPassword = AES.getAES(slotData.newPassword)
				// let { password: oldPwd, newPassword: pwd, repeatPassword: Newpwd } = slotData
				console.log('1--', slotData)
				JSON.stringify()
				updatePassword({
					oldPwd: oldPassword,
					pwd: newPassword,
					Newpwd: newPassword
				}).then(data => {
					if (data.code == 0) {
						store.dispatch("set_updatePassword", slotData.newPassword)
						successMsg(data.message)
						data.showPop = false
						methods.exitFn()
					} else {
						errMsg(data.message)
					}
				})
			},
			menuSelect(index) {
				console.log(index, 'sssssss')
				let obj = JSON.parse(index)

				methods.naviItemClick(obj)
			},
			collaMenu() {
				data.collaMenuData = !data.collaMenuData
			},
			tabsMoreClick() {
				data.showTabsMoreShift = !data.showTabsMoreShift
			},
			tabsMoreClose() {
				data.showTabsMoreShift = false
			},
			closeCurrent() {
				let current = data.selectedTab
				methods.tabClose(current)
			},
			closeOther() {
				let current = computeds.selectedTab.value
				let tabs = computeds.tabs.value

				let index = tabs.findIndex(f => f.path == current)
				let newTabs = [tabs[0]]

				if (index != 0) {
					newTabs.push(tabs[index])
				}

				store.dispatch("update_tabs", newTabs)
			},
			closeAll() {
				let tabs = computeds.tabs.value

				let newTabs = [tabs[0]]
				console.log(newTabs)
				store.dispatch("update_tabs", newTabs)
				store.dispatch("set_selectedTab")
				router.push(tabs[0].path)
			},
			// 消息通知 opacity: 1;
			infoPop(){
				data.chatBox = true
				setTimeout(()=>{
					data.chatBox = false
				}, 10000)
			}
		}

		let computeds = {
			naviData: computed(() => {
				return store.getters.getNaviData
			}),
			tabs: computed(() => {
				return store.getters.getTabs
			}),
			selectedTab: computed(() => {
				return store.getters.getCurrentChildRouterPath
			}),
			getUserName: computed(() => {
				return store.getters.getUserName
			})
		}

		onMounted(() => {
			window.addEventListener("beforeunload", e => this.memoryUserFn(e))
			data.userName = JSON.parse(localStorage.getItem("user_name"))
			let path = store.getters.getCurrentChildRouterPath
			if (path == null) {
				path = "/home/firstPage"
			}
			router.push(path)
		})

		return {
			...toRefs(data),
			...methods,
			...computeds
		}
	}
})
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

.el-menu {
	border-right: 0;
}

.main-container {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	box-sizing: border-box;
	@include background_color("home_bg-color");

	.main-container-body {
		flex: 1;
		height: 0;
		width: 100%;
		display: flex;
		box-sizing: border-box;

		.body-left {
			height: 100%;
			width: 250px;
			// @include border-right("home_body_left_border_right");
			@include background_color("body_left_bg-color");
			display: flex;
			flex-direction: column;
			box-sizing: border-box;
			transition: all .6s;

			&.body-left-colla {
				width: 65px;
			}

			.menu-container {
				height: 60px;
				width: 100%;
				@include background_color("body_left_bg-color");
				display: flex;
				justify-content: space-between;
				align-items: center;
				align-content: center;
				padding-left: 20px;
				padding-right: 20px;
				box-sizing: border-box;

				.left {
					width: (352px/5);
					height: (208px/5);
					@include background_image("body_left_logo");
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}

				.right {
					width: 16px;
					height: 14px;
					@include background_image("body_left_fold");
					background-repeat: no-repeat;
					background-size: 100% 100%;

					&.right-colla {
						@include background_image("body_left_upfold");
					}

					&:hover {
						cursor: pointer;
					}

				}
			}

			.body-left-menu {
				flex: 1;
				height: 0;
				overflow: auto;
			}
		}

		.body-right {
			flex: 1;
			height: 100%;
			display: flex;
			flex-direction: column;
			@include background_color("body_right_bg-color");
			box-sizing: border-box;
			padding: 1px;
			overflow: hidden;
			// font-family: hanSan ;

			// .header {
			// 	width: 100%;
			// 	height: 60px;
			// 	@include background_color("home_header_bg-color");
			// 	display: flex;
			// 	justify-content: space-between;
			// 	align-items: center;
			// 	align-content: center;

			// 	.header-container {
			// 		height: 100%;
			// 		width: auto;
			// 		display: flex;
			// 		align-items: center;
			// 		align-content: center;

			// 		.header-container-title {
			// 			height: 20px;
			// 			width: auto;
			// 			margin-left: 44px;
			// 			@include font_color("home_header_company_name_color");
			// 			font-size: 20px;
			// 			@include font_family("font_family");
			// 			line-height: 20px;
			// 		}

			// 		.icon {
			// 			height: 100%;
			// 			width: 100%;

			// 			&.manager {
			// 				@include background_image("home_header_button_manage_image");
			// 			}

			// 			&.message {
			// 				@include background_image("home_header_button_message_image");
			// 			}

			// 			&.user-info {
			// 				@include background_image("home_header_button_user_info_image");
			// 			}
			// 		}
			// 	}
			// 	.header-pwd{
			// 		border: 1px solid #6486e8;
			// 		margin-top: -13px;
			// 		border-radius: 8px;
			// 		margin-right: -12px;
			// 	}
			// }

			.body-right-header {
				height: 48px;
				width: 100%;
				@include background_color("home_body_center_header_bg-color");
				//@include border_bottom("home_body_center_header_border_bottom");
				display: flex;
				box-sizing: border-box;

				.tabs-more {
					width: 150px;
					height: 85%;
					display: flex;
					justify-content: center;
					align-items: center;
					align-content: center;
					box-sizing: border-box;
					// @include border_all("tab_more_left_line");
					border: 1px solid rgba(241, 241, 241, 0.5);
					position: relative;

					.icon {
						width: 150px;
						height: 28px;
						display: flex;
						align-items: center;
						align-content: space-between;
						justify-content: space-between;
						// @include background_image("tab_more_icon_image");
						// background-image: url("../../public/static/images/auser.png");
						background-repeat: no-repeat;
						background-size: 100% 100%;

						.icon-bg {
							width: 24px;
							background-size: 100%;
							background-repeat: no-repeat;
							height: 100%;
							background-image: url("../../public/static/images/auser.png");
						}

						.icon-user-name {
							width: 120px;
							height: 100%;
							display: flex;
							justify-content: space-around;
							font-size: 16px;
							align-items: center;

						}

					}

					.shift {
						position: absolute;
						width: 96px;
						padding-top: 5px;
						padding-bottom: 5px;
						height: auto;
						box-sizing: border-box;
						@include background_color("tab_more_shift_bgClor");
						top: 100%;
						right: 0;
						margin-top: 5px;
						display: flex;
						flex-direction: column;
						box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .3);
						z-index: -1;
						opacity: 0;
						transform: translateY(-100%);
						transition: all .5s;

						&.shift-show {
							z-index: 10;
							opacity: 1;
							transform: translateY(0);
						}

						.shift-item {
							width: 100%;
							height: 30px;
							display: flex;
							justify-content: center;
							align-items: center;
							align-content: center;
							@include font_family("font_family");
							font-size: 14px;
							@include font_color("tab_more_shift_item_font_color");

							&:hover {
								@include background_color("tab_more_shift_bgClor_selected");
								@include font_color("tab_more_shift_item_font_color_selected");
								cursor: pointer;
							}
						}
					}
				}

				.body-right-header-tabs {
					width: 0;
					flex: 1;
					height: 100%;
				}

				.body-right-header-button-container {
					height: 100%;
					width: 40px;
					display: flex;
					justify-content: center;
					align-items: center;
					align-content: center;
					@include border_right("home_body_center_header_button_border_right");
					@include border_left("home_body_center_header_button_border_left");
					cursor: pointer;

					.body-right-header-button {
						height: 12px;
						width: 12px;
						@include background_image("home_body_center_header_left_button_image");
						background-repeat: no-repeat;
						background-size: 100% 100%;


						&.right {
							@include background_image("home_body_center_header_right_button_image");
						}
					}
				}

				.body-right-header-center {
					height: 100%;
					flex: 1;
					overflow: hidden;
					position: relative;

					.body-right-header-center-content {
						height: 100%;
						width: fit-content;
						display: flex;
						white-space: nowrap;
						position: absolute;
					}
				}
			}

			.body-right-body {
				width: 100%;
				height: 0;
				flex: 1;
				flex-shrink: 0;
				padding: 5px 12px;
				box-sizing: border-box;
				// overflow: auto;
				overflow-y: auto;
    			overflow-x: hidden;
				flex-flow: column;
			}
			/* 设置滚动条的样式 */
			.homePage::-webkit-scrollbar,.body-left-menu::-webkit-scrollbar{
			width:12px;
			}
			/* 滚动槽 */
			.homePage::-webkit-scrollbar-track,.body-left-menu::-webkit-scrollbar-track{
			-webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
			border-radius:10px;
			}
			/* 滚动条滑块 */
			.homePage::-webkit-scrollbar-thumb,.body-left-menu::-webkit-scrollbar-thumb {
			border-radius:10px;
			background:rgba(0,0,0,0.1);
			-webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
			}
			.homePage::-webkit-scrollbar-thumb:window-inactive,.body-left-menu::-webkit-scrollbar-thumb:window-inactive{
			background:rgba(247, 88, 88, 0.4);
			}
		}
	}
	// :deep(.el-table__header)
	:deep(.el-submenu__title){
		font-size: 0.083333rem !important;
		font-family: hanSan !important;
		font-weight: 500;
	}
	:deep(.el-menu-item){
		font-size: 0.083333rem !important;
		font-family: hanSan !important;
		font-weight: normal;
	}
	/* 设置滚动条的样式 */
	.body-left-menu::-webkit-scrollbar{
	width:12px;
	}
	/* 滚动槽 */
	.body-left-menu::-webkit-scrollbar-track{
	-webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
	border-radius:10px;
	}
	/* 滚动条滑块 */
	.body-left-menu::-webkit-scrollbar-thumb {
	border-radius:10px;
	background:rgb(215, 215, 215);
	-webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
	}
	.body-left-menu::-webkit-scrollbar-thumb:window-inactive{
	background:rgba(247, 88, 88, 0.4);
	}
}
.infoPop{
	display: none;
	position: absolute;
	width: 500px;
	height: 200px;
	border: 3px solid red;
	text-align: center;
	color: white;
	background-color: gray;
	bottom: 80px;
	left: 5px;
	opacity: 0;
	transition:opacity 2s;
	-webkit-transition:opacity 2s; /* Safari */
}
.infoPopTransition{
	display: block;
	opacity: 1;
}
</style>
